export default __webpack_public_path__ + "static/media/Academy_HTB.5717be81.md";